export default Object.freeze({
  ONGOING: 'ONGOING',
  PAUSED: 'PAUSED',
  CLOSED: 'CLOSED',
  URGENT: 'URGENT',
});
